/**
 * <nia-announcement>
 * Carrusel de anuncios con crossfade. Rota solo, se pausa al pasar el cursor
 * y cuando la pestaña deja de estar visible. Las flechas reinician el temporizador.
 */
class NiaAnnouncement extends HTMLElement {
  #timer = null;
  #index = 0;
  #paused = false;

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.nia-ann__item'));
    this.viewport = this.querySelector('.nia-ann__viewport');
    if (this.items.length < 2) return;

    this.interval = Number(this.dataset.interval) || 5200;
    this.#index = this.items.findIndex((item) => item.classList.contains('is-active'));
    if (this.#index < 0) this.#index = 0;

    this.querySelector('.nia-ann__arrow--prev')?.addEventListener('click', () => this.#step(-1, true));
    this.querySelector('.nia-ann__arrow--next')?.addEventListener('click', () => this.#step(1, true));

    this.addEventListener('pointerenter', this.#pause);
    this.addEventListener('pointerleave', this.#resume);
    this.addEventListener('focusin', this.#pause);
    this.addEventListener('focusout', this.#resume);
    document.addEventListener('visibilitychange', this.#onVisibilityChange);

    this.#start();
  }

  disconnectedCallback() {
    this.#stop();
    document.removeEventListener('visibilitychange', this.#onVisibilityChange);
  }

  #start() {
    this.#stop();
    if (this.#paused || document.hidden) return;
    this.#timer = setInterval(() => this.#step(1, false), this.interval);
  }

  #stop() {
    if (this.#timer) clearInterval(this.#timer);
    this.#timer = null;
  }

  #pause = () => {
    this.#paused = true;
    this.#stop();
  };

  #resume = () => {
    this.#paused = false;
    this.#start();
  };

  #onVisibilityChange = () => {
    document.hidden ? this.#stop() : this.#start();
  };

  /**
   * @param {number} direction -1 anterior, 1 siguiente.
   * @param {boolean} fromUser true si lo disparó una flecha: reinicia el temporizador
   *   y activa el anuncio de la región viva, que se mantiene en silencio mientras rota sola.
   */
  #step(direction, fromUser) {
    const total = this.items.length;
    this.items[this.#index]?.classList.remove('is-active');
    this.#index = (this.#index + direction + total) % total;
    this.items[this.#index]?.classList.add('is-active');

    if (fromUser) {
      this.viewport?.setAttribute('aria-live', 'polite');
      this.#start();
    }
  }
}

if (!customElements.get('nia-announcement')) {
  customElements.define('nia-announcement', NiaAnnouncement);
}
